import { useTranslation } from "react-i18next";
import { AlertTriangle, MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "96566098080";

/**
 * Full-screen maintenance overlay shown when the admin has toggled
 * maintenance mode on. Blocks use of the site and points the customer
 * to WhatsApp (66098080).
 */
export function MaintenanceOverlay({ message }: { message?: string }) {
  const { t } = useTranslation();
  const text = message || t("maintenance.defaultMessage");
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}`;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-background p-6">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="mx-auto w-fit rounded-full bg-amber-100 p-5 dark:bg-amber-900/30">
          <AlertTriangle className="h-12 w-12 text-amber-600 dark:text-amber-400" />
        </div>
        <h1 className="text-2xl font-bold">{t("maintenance.title")}</h1>
        <p className="text-muted-foreground leading-relaxed">{text}</p>
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 rounded-md bg-green-600 px-6 py-3 font-medium text-white hover:bg-green-700 transition-colors"
        >
          <MessageCircle className="h-5 w-5" />
          {t("maintenance.contactWhatsApp")}
        </a>
      </div>
    </div>
  );
}
